import { useState, useRef, useEffect} from 'react'
import { SubTitle } from './Text';
import React, { CSSProperties, FC } from 'react';
import './UnitStyles.css'



interface AlertProps {
    alertState: boolean;
    alertHandler: (value: boolean) => void
    alertTitle: string;
    children: React.ReactNode; // Type for children
    className?: string; // Optional additional class names
    style?: CSSProperties; 
}


const Alert: FC<AlertProps> = ({
    alertState, 
    alertHandler,
    alertTitle,
    children,
    className = "",
    style,
    ...props
}) => {
    const alertWrapperRef = useRef<HTMLDivElement | null>(null);
    const alertContentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const isOutSideClick = alertWrapperRef.current && event.target instanceof Node && alertWrapperRef?.current?.contains(event.target) ? true : false
            const isContentAreaClick = alertContentRef.current && event.target instanceof Node && alertContentRef.current.contains(event.target) ? true : false
            if (isOutSideClick && !isContentAreaClick) {
                alertHandler(false);
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const alertClasses = `show-up-quick alert-wrapper ${alertState ? "flex":"display-none"}`
    return (
        <div className={alertClasses} ref={alertWrapperRef}>
            <div className="alert-content" ref={alertContentRef} style={style}>
                <SubTitle>{alertTitle}</SubTitle>
                <div>
                    { children }
                </div>
            </div>
        </div>
    )
}


export default Alert